export enum ErrorCodes {
  LoginError = 'EUTO0P0001',
  MissingStepDataError = 'EUTO0P0002',
  UnsupportedStepError = 'EUTO0P0003',
  UserCanceledError = 'EUTO0P0004',
  UserRequestedSignOutError = 'EUTO0P0005',
  UnknownOnboardingError = 'EUTO0P0006',
  TenantSelectorError = 'EUTO0P0007',
  ValuePropositionError = 'EUTO0P0008',
  LoadingScreenTimeoutError = 'EUTO0P0009',
  ValuePropositionDeclined = 'EUTO0P0010',
  IsUserOnboardedError = 'EUTO0P0011',
  ForceLoginError = 'EUTO0P0012',
  OnboardingMissingTenantId = 'EUTO0P0013',
  OnboardingTimeoutError = 'EUTO0P0014'
}

export enum ErrorType {
  UserCanceled = 'userCanceled'
}

export type UserTenantOnboardingError = {
  errorCode: ErrorCodes;
  message: string;
};
